"use strict";

import angular from "angular";

export class ToastTemplateCtrl {
    constructor($mdToast, locals) {
        this.$mdToast = $mdToast;
        this.locals = locals;
    }

    $onInit() {}
}

angular.module("nucont.shared").controller("ToastTemplateCtrl", [
    "$mdToast",
    "locals",
    ToastTemplateCtrl
]);
